(function() {
    angular
        .module("app")
        .factory("messagesService", messagesService)

    messagesService.$inject = ["$rootScope", "$http"]

    function messagesService($rootScope, $http) {
        var service = {}

        var messageBoardData
        var graphicMessageBoardData

        /**
            Create text message data
            @param messageNumber
            @param formData
            @param pageCount
            @todo Rename to reflect text message
         **/
        service.createMessageData = function(messageNumber, formData, pageCount) {

            var data = {
                message: {
                    num_pages: pageCount,
                    message_number: messageNumber,
                    activate: false
                }
            }

            angular.forEach(formData, (value, key) => {
                data.message[key] = value
            })

            messageBoardData = data
        }

        /**
            Get text message data
            @returns {*}
            @todo Rename to reflect text message
         **/
        service.getMessageData = function() {

            return messageBoardData
        }

        /**
            Create graphic message data
            @param messageNumber
         **/
        service.createGraphicMessageData = function(messageNumber) {

            var pixelsObj = new Object()
            graphicMessage.getColors(pixelsObj, function() {
                var designObj = new Object()
                graphicMessage.saveSignDesign(designObj,
                    function() {
                        var MessageData = {
                            message_number: messageNumber,
                            num_pages: graphicMessage.getNumPages(),
                            activate: $("#activate").is(":checked"),
                            pixels: service.formatPixels(pixelsObj.colArray),
                            design: designObj.json
                        }

                        graphicMessageBoardData = {
                            message: MessageData
                        }
                    }) // end saveSignDesign
            }) // end getColors
        }

        /**
            Format pixels data for graphic message data
            @param pageArray
            @returns {{}}
         **/
        service.formatPixels = function(pages) {

            var pixelsFormatted = {}

            for (var pg = 0; pg < pages.length; pg++) {

                var rows = pages[pg]
                var pageName = String(pg)
                pixelsFormatted[pageName] = {}

                for (var r = 0; r < rows.length; r++) {

                    var pixels = rows[r]
                    pixelsFormatted[pageName][r] = []

                    for (var pi = 0; pi < pixels.length; pi++) {

                        pixelsFormatted[pageName][r][pi] = pixels[pi]

                    }
                }
            }

            return pixelsFormatted
        }

        /**
            Get graphic message data
            @returns {*}
         **/
        service.getGraphicMessageData = function() {
            return graphicMessageBoardData
        }

        /**
            Extract text message data
            @param pages
            @returns {{}}
            @todo Rename to reflect text message
         **/
        service.extractMessageData = function(pages) {
            var dataFormatted = {},
                currentPage,
                currentPageNum,
                currentLine,
                currentLineNum

            var pi = 0
            angular.forEach(pages, (page) => {

                pi++
                currentPageNum = "p" + pi

                if (!dataFormatted.hasOwnProperty("vertical_alignment")) {
                    dataFormatted["vertical_alignment"] = {}
                }

                if (page.hasOwnProperty("vertical_alignment") && page["vertical_alignment"] != "") {
                    dataFormatted["vertical_alignment"][currentPageNum] = page.vertical_alignment
                }

                var li = 0
                angular.forEach(page.lines, (line) => {

                    li++
                    currentLineNum = "l" + li

                    angular.forEach(line, (value, key) => {

                        if (!dataFormatted.hasOwnProperty(key)) {
                            dataFormatted[key] = {}
                        }

                        if (!dataFormatted[key].hasOwnProperty(currentPageNum)) {
                            dataFormatted[key][currentPageNum] = {}
                        }

                        if (!dataFormatted[key][currentPageNum].hasOwnProperty(currentLineNum)) {
                            dataFormatted[key][currentPageNum][currentLineNum] = {}
                        }

                        dataFormatted[key][currentPageNum][currentLineNum] = value

                    })
                })
            })

            return dataFormatted
        }

        /**
            Get message by message ID
            @param {int} messageBoardID
            @param {int} messageID
            @returns {*}
         **/
        service.getMessage = function(messageBoardID, messageID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages/" + messageID
            }).then(getMessagesComplete, getMessagesFailed)

            function getMessagesComplete(response) {
                return response.data
            }

            function getMessagesFailed(error) {
                console.error(error)
            }
        }

        /**
            Get Message Associated Events
            @param {int} messageBoardID
            @param {int} messageID
            @returns {*}
         **/
        service.getAssociatedEvents = function(messageBoardID, messageID, successCallback, failureCallback) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages/" + messageID + "/associated_events"
            }).then(getAssociatedEventsComplete, getAssociatedEventsFailed)

            function getAssociatedEventsComplete(response) {
                successCallback(response.data)
            }

            function getAssociatedEventsFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        service.createMessage = function(messageBoardID, formData, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/",
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(createMessageComplete, createMessageFailed)

            function createMessageComplete(response) {
                successCallback(response.data)
                return response.data
            }

            function createMessageFailed(error) {
                // var error_message = ""
                // if (error.data.errors.name) {
                //     error_message = "Message Number " + error.data.errors.name[0]
                // }

                failureCallback(error.data.errors[0])
                console.error(error)
            }
        }

        service.createMessageV2 = function(messageBoardID, messageData, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/create_v2",
                headers: {
                    "Accept": "application/json"
                },
                data: messageData
            }).then(createMessageComplete, createMessageFailed)

            function createMessageComplete(response) {
                successCallback(response.data)
                return response.data
            }

            function createMessageFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        service.exportMessage = function(messageBoardID, formData, success, failure) {

            const _success = (response) => {

                try {

                    const blob       = new Blob(response.data.split())
                    const url        = window.URL.createObjectURL(blob)
                    const a          = document.createElement("a")
                    const header     = unescape(response.headers()["content-disposition"])
                    const startIndex = header.indexOf("filename=")

                    let filename = header.slice(startIndex + 9)

                    if (!filename || filename === "" || filename === "d") {
                        filename = "graphic_message.multi"
                    }

                    a.style    = "display: none"
                    a.href     = url
                    a.download = filename

                    document.body.appendChild(a)
                    a.click()

                    document.body.removeChild(a)
                    window.URL.revokeObjectURL(url)
                    success(filename)

                } catch(error) {
                  _failure({ data: { error: error }})
                }
            }

            const _failure = (error) => {
                if (failure) {
                    console.error(error.data.error)
                    failure(error.data.error)
                }
            }

            return $http({
                method:  "POST",
                url:     $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/export",
                headers: { "Accept": "application/json" },
                data:    formData
            }).then(_success, _failure)
        }

        /**
            Create new graphic message
            @param messageBoardID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.createGraphicMessage = function(messageBoardID, formData, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/",
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(createMessageComplete, createMessageFailed)

            function createMessageComplete(response) {
                successCallback(response.data)
                return response.data
            }

            function createMessageFailed(error) {
                var error_message = ""
                if(error.data.errors.name) {
                    error_message = "Message Number " + error.data.errors.name[0]
                }

                failureCallback(error_message)
                console.error(error)
            }
        }

        /**
            Create message preview
            @param messageBoardID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.previewMessage = function(messageBoardID, formData, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/preview",
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(previewMessageComplete, previewMessageFailed)

            function previewMessageComplete(response) {
                successCallback(response.data)
                return response.data
            }

            function previewMessageFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Edit existing message
            @param messageBoardID
            @param messageID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
            @todo Implement into site
         **/
        service.editMessage = function(messageBoardID, messageID, formData, successCallback, failureCallback) {
            formData.message.message_number = ""

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/" + messageID,
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(editMessageComplete, editMessageFailed)

            function editMessageComplete(response) {
                console.log("Edit Message Success: ", response)

                successCallback()
                return response.data
            }

            function editMessageFailed(error) {
                console.error("Edit Message Error ", error)

                failureCallback(error)
            }
        }

        /**
            Broadcast multiple messages
            @param messageBoardIDs
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.broadcastMessage = function(messageBoardIDs, formData, successCallback, failureCallback) {
            formData.message_board_ids = messageBoardIDs

            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/messages/broadcast",
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(broadcastMessageComplete, broadcastMessageFailed)

            function broadcastMessageComplete(response) {
                successCallback(response)
                return response.data
            }

            function broadcastMessageFailed(error) {

                if (error !== undefined && error.hasOwnProperty("data") && error.data.hasOwnProperty("error")) {
                    failureCallback(error.data.error)
                } else {
                    failureCallback()
                }

                // var errorMessages = []
                // var successMessages = []
                // console.error(error)
                // angular.forEach(error.data, function(value, key) {
                //     if(value.errors) {
                //         angular.forEach(value.errors, function(errorValue, errorKey) {
                //             angular.forEach(errorValue, function(messageValue, messageKey) {
                //                 errorMessages.push(
                //                     "Message " + errorKey
                //                     + " for message board with the ID of " +  value.message_board_id + " "
                //                     + messageValue)
                //             })
                //         })
                //     }

                //     if(value.id) {
                //         successMessages.push(
                //             "Message " + value.name + " created successfully for message board with the ID of " + value.message_board_id
                //         )
                //     }
                // })

                // failureCallback(errorMessages, successMessages)
            }
        }

        /**
            Activate message
            @param {int} messageBoardID
            @param {int} messageID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.activateMessage = function(messageBoardID, messageID, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/" + messageID + "/activate"
            }).then(activateMessageComplete, activateMessageFailed)

            function activateMessageComplete(response) {
                successCallback()
                return response.data
            }

            function activateMessageFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Delete message
            @param {int} messageBoardID
            @param {int} messageID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.deleteMessage = function(messageBoardID, messageID, successCallback, failureCallback) {
            return $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/messages/" + messageID + "/delete"
            }).then(deleteMessageComplete, deleteMessageFailed)

            function deleteMessageComplete(response) {
                successCallback()
                return response.data
            }

            function deleteMessageFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Clone message to single device
            @param messageBoardID
            @param messageIDs
            @param messageBoardIDs
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.cloneMessageToDevice = function(messageBoardID, messageIDs, messageBoardIDs, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/clone",
                data: {
                    "clone_message_ids": messageIDs,
                    "clone_to_message_board_ids":  messageBoardIDs
                }
            }).then(cloneMessageToDeviceComplete, cloneMessageToDeviceFailed)

            function cloneMessageToDeviceComplete(response) {
                successCallback()
                return response.data
            }

            function cloneMessageToDeviceFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Clone message to multiple devices
            @param {int} messageBoardID
            @param messageIDs
            @param messageBoardIDs
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.cloneMessageToDevices = function(messageBoardID, messageIDs, messageBoardIDs, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/clone",
                data: {
                    "clone_message_ids": messageIDs,
                    "clone_to_message_board_ids":  this.parseMessageBoardIDs(messageBoardIDs)
                }
            }).then(cloneMessageToDevicesComplete, cloneMessageToDevicesFailed)

            function cloneMessageToDevicesComplete(response) {
                successCallback()
                return response.data
            }

            function cloneMessageToDevicesFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Parse message board IDs
            @param messageBoardIDs
            @returns {Array}
         **/
        service.parseMessageBoardIDs = function(messageBoardIDs) {
            var query = []

            angular.forEach(messageBoardIDs, function(value, key) {
                if (value) {
                    query.push(key)
                }
            })

            return query
        }

        return service
    }
})()
